// Only explicit zero rates are free. Missing prices and variable billing are not.
export const isZeroPrice = (value) =>
  (typeof value === 'number' || (typeof value === 'string' && value.trim() !== '')) &&
  Number(value) === 0;

export const isFreeEndpoint = (ep) => {
  if (!ep) return false;
  if (ep.protocol === 'WEBSOCKET') {
    const billing = ep.wsBilling || ep._raw?.wsBilling;
    if (billing?.kind === 'duration') return isZeroPrice(billing.perMinuteUsd);
    if (billing?.kind === 'per-char') return isZeroPrice(billing.perCharUsd);
    return false;
  }
  const type = ep.billingType || 'PER_CALL';
  if (type === 'PER_CALL') return isZeroPrice(ep.costPerCall);
  if (type === 'PER_RESOURCE') return isZeroPrice(ep.costPerResource);
  return false;
};

export const endpointListCost = (ep) => {
  if (isFreeEndpoint(ep)) return 'free';
  if (ep.protocol === 'WEBSOCKET') return 'usage-based';
  const type = ep.billingType || 'PER_CALL';
  if (type === 'PER_TOKEN') return 'per-token';
  if (type === 'DYNAMIC') return 'rule-based';
  if (type === 'PER_RESOURCE') {
    return Number(ep.costPerResource) > 0 ? `$${ep.costPerResource}/res` : 'per-resource';
  }
  return ep.costPerCall != null && ep.costPerCall !== '' ? `$${ep.costPerCall}` : '—';
};
